// extracted by mini-css-extract-plugin
export default {"notificationsStroke":"t6xC1j","notificationsFill":"syrTTa"};